import React from 'react';

import styles from './XArticle.module.scss';
import {DateTime} from "luxon";
import {} from "../../Utilities/Utilities";
import {XArticleSticker} from './XArticleSticker';


interface IArticleHeaderProps {
    children? : React.ReactNode;
}

interface IArticleHeaderState {
}

class XArticleHeader extends React.Component<IArticleHeaderProps, IArticleHeaderState> {
    render(): React.ReactNode {
        return (
            <div className={styles.XArticleHeader}>
                {this.props.children}
            </div>
        );
    }
}

export interface IArticleDateProps {
    className?: string | null;
    date: DateTime<true>;
}

export class XArticleDate extends React.Component<IArticleDateProps>{
    public constructor(props: IArticleDateProps) {
        super(props);
    }
    render() : React.ReactNode{
        return (
            <div className={styles.XArticleDate}>
                <div className={styles.XRow}>
                    {this.props.date.setLocale('ru').toFormat('dd')}
                </div>
                <div className={styles.XRow}>
                    {this.props.date.setLocale('ru').toFormat('MMMM').capitalize()}
                </div>
                <div className={styles.XRow}>
                    {this.props.date.setLocale('ru').toFormat('yyyy')}
                </div>
            </div>
        );
    }
}

export interface IArticleProps {
    className?: string | null;
    children? : React.ReactNode;
    stickers? : (React.ReactElement<XArticleSticker> | Iterable<React.ReactElement<XArticleSticker>>) & React.ReactNode;
    header? : React.ReactNode;
}

export interface IArticleState {
}
export class XArticle extends React.Component<IArticleProps, IArticleState> {
    public constructor(props: IArticleProps) {
        super(props);
    }
    render() : React.ReactNode
    {
        return (
            <div className={styles.XArticle}>
                <div className={styles.XLeft}>
                    {this.props.stickers}                    
                    <div className={styles.XExpander}/>
                    <XArticleDate date={DateTime.now()}/>
                </div>
                <div className={styles.XClient}>
                    {this.props.header && (<XArticleHeader>{this.props.header}</XArticleHeader>)}
                    <div className={styles.XContent}>
                        {this.props.children}
                    </div>                    
                </div>
            </div>
        );
    }
}